import React from "react";
import { Link } from "react-router-dom";
import s from "../styles/PolicyIndex.module.css";

const apps = [
  {
    id: "whitenoise",
    name: "White Noise: Calm Sleep",
    path: "/apps/whitenoise/accountremove",
  },
  {
    id: "qrbarcode",
    name: "QR & Barcode Scanner: Fast Reader Pro",
    path: "/apps/qrbarcode/accountremove",
  },
  {
    id: "smartgps",
    name: "Smart gps compass",
    path: "/apps/smartgps/accountremove",
  },
  {
    id: "notespark",
    name: "Note Spark: Ai Note Taker",
    path: "/apps/notespark/accountremove",
  },
  {
    id: "magicerace",
    name: "Magic Eracer: Remove object",
    path: "/apps/magicerace/accountremove",
  },
  {
    id: "seekaichat",
    name: "Seek Ai Chat",
    path: "/apps/seekaichat/accountremove",
  },
  {
    id: "nola",
    name: "Nola AI Chat Friend",
    path: "/apps/nola/accountremove",
  },
  {
    id: "hwsolver",
    name: "Ai Homework Solver",
    path: "/apps/hwsolver/accountremove",
  },
  {
    id: "photo_vaylt",
    name: "Veilify Photo Vault",
    path: "/apps/photo_vaylt/accountremove",
  },
  {
    id: "voice_changer",
    name: "Voice changer pro",
    path: "/apps/voice_changer/accountremove",
  },
  {
    id: "colorie_counter",
    name: "Ai Calorie counter: food tracker",
    path: "/apps/colorie_counter/accountremove",
  },
  {
    id: "invoice_maker",
    name: "Invoice Maker for Contractors",
    path: "/apps/invoice_maker/accountremove",
  },
  {
    id: "smart_spy",
    name: "Smart Spy Detector (MVP)",
    path: "/apps/smart_spy/accountremove",
  },
  {
    id: "collage_ai",
    name: "Smart Collage Ai",
    path: "/apps/collage_ai/accountremove",
  },
  {
    id: "trader_lab",
    name: "Trader Lab",
    path: "/apps/trader_lab/accountremove",
  },
  {
    id: "wishflow",
    name: "WishFlow",
    path: "/apps/wishflow/accountremove",
  },
  {
    id: "brainiq",
    name: "BrainIQ: Boost Your Mind",
    path: "/apps/brainiq/accountremove",
  },
  {
    id: "puretrackervaping",
    name: "PureTracker: Quit Vaping",
    path: "/apps/puretrackervaping/accountremove",
  },
  {
    id: "puretrackerdrinking",
    name: "PureTracker: Quit Drinking",
    path: "/apps/puretrackerdrinking/accountremove",
  },
  {
    id: "pupverse",
    name: "Pupverse: Dog Training",
    path: "/apps/pupverse/accountremove",
  },
  {
    id: "schedula",
    name: "Schedula",
    path: "/apps/schedula/accountremove",
  },
];

export default function AccountRemoveIndex() {
  return (
    <div className={s.wrapper}>
      <h2>Account removal</h2>
      <ul className={s.appList}>
        {apps.map((app) => (
          <li key={app.id} className={s.appListItem}>
            <Link to={app.path} className={s.appLink}>
              {app.name}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
